import { Button, Text } from '@/components/DesignSystem';
import { Stack, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const retailerAppFooterHeight = 64;

export const RetailerAppFooter = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      bgcolor={theme.palette.background.default}
      borderTop="1px solid rgba(0, 0, 0, 0.04)"
      bottom={0}
      data-testid="app-footer"
      direction="row"
      height={`${retailerAppFooterHeight}px`}
      justifyContent="space-between"
      p="16px 32px"
      position="fixed"
      width="100%"
      zIndex={theme.zIndex.appBar}
    >
      <Stack alignItems="center" direction="row">
        <Text category="body-small" sx={{ color: '#393939' }}>
          {t($ => $.app.branding.poweredBy)}&nbsp;
        </Text>
        <Text
          category="body-small"
          fontWeight={700}
          letterSpacing={0.5}
          sx={{ color: '#393939' }}
        >
          GROWERS
        </Text>
      </Stack>
      <Stack direction="row">
        <Button
          href="https://growers.ag/privacy-policy/#privacypolicy"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            window.open('https://growers.ag/privacy-policy/#privacypolicy', '_blank');
          }}
          testID="privacy-policy-button"
          variant="text"
        >
          {t($ => $.app.footer.privacyPolicy)}
        </Button>
        <Button
          href="https://growers.ag/privacy-policy/#termsofuse"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            window.open('https://growers.ag/privacy-policy/#termsofuse', '_blank');
          }}
          testID="terms-of-use-button"
          variant="text"
        >
          {t($ => $.app.footer.termsOfUse)}
        </Button>
      </Stack>
    </Stack>
  );
};
